import { GET_ADDED_CONTACTS_INFO, GET_ADDED_CONTACTS_INFO_SUCCESS, GET_ADMIN_LIST, GET_ADMIN_LIST_SUCCESS, GET_DELETED_CONTACTS_INFO, GET_DELETED_CONTACTS_INFO_SUCCESS, GET_HIDDEN_ENTITIES_INFO, GET_HIDDEN_ENTITIES_INFO_SUCCESS, GET_MEMBER_ACTIVITY_INFO, GET_MEMBER_ACTIVITY_INFO_SUCCESS, GET_MEMBER_STATISTICS_INFO, GET_MEMBER_STATISTICS_INFO_SUCCESS, GET_STARRED_ENTITIES_INFO, GET_STARRED_ENTITIES_INFO_SUCCESS, SET_ADM_MEMBER_STATISTICS_ERROR, SET_ADM_MEMBER_STATISTICS_LOADING, SET_ADM_MEMBER_STATISTICS_RESULT, SET_ADM_MEMBER_STATISTICS_SUCCESS, SET_CONTACTS_LOG, SET_ENTITIES_STAR_HIDE_LOG, UPDATE_SALES_OWNER, UPDATE_SALES_OWNER_SUCCESS } from "./actionTypes"

export const setAdmMemberStatisticsLoading = data => {
    return {
        type: SET_ADM_MEMBER_STATISTICS_LOADING,
        payload: data,
    }
}

export const setAdmMemberStatisticsError = data => {
    return {
        type: SET_ADM_MEMBER_STATISTICS_ERROR,
        payload: data,
    }
}

export const setAdmMemberStatisticsSuccess = data => {
    return {
        type: SET_ADM_MEMBER_STATISTICS_SUCCESS,
        payload: data,
    }
}

export const setAdmMemberStatisticsResult = data => {
    return {
        type: SET_ADM_MEMBER_STATISTICS_RESULT,
        payload: data,
    }
}

export const getMemberStatisticsList = data => {
  return {
    type: GET_MEMBER_STATISTICS_INFO,
    payload: data,
  }
}

export const getMemberStatisticsListSuccess = data => {
  return {
    type: GET_MEMBER_STATISTICS_INFO_SUCCESS,
    payload: data,
  }
}

export const getMemberActivityList = data => {
  return {
    type: GET_MEMBER_ACTIVITY_INFO,
    payload: data,
  }
}

export const getMemberActivityListSuccess = data => {
  return {
    type: GET_MEMBER_ACTIVITY_INFO_SUCCESS,
    payload: data,
  }
}

export const getAddedContactsList = data => {
  return {
    type: GET_ADDED_CONTACTS_INFO,
    payload: data,
  }
}

export const getAddedContactsListSuccess = data => {
  return {
    type: GET_ADDED_CONTACTS_INFO_SUCCESS,
    payload: data,
  }
}

export const getDeletedContactsList = data => {
  return {
    type: GET_DELETED_CONTACTS_INFO,
    payload: data,
  }
}

export const getDeletedContactsListSuccess = data => {
  return {
    type: GET_DELETED_CONTACTS_INFO_SUCCESS,
    payload: data,
  }
}

export const setAdmMemberActivityContactsLog = data => {
    return {
        type: SET_CONTACTS_LOG,
        payload: data,
    }
}

export const getAdminList = () => {
    return {
        type: GET_ADMIN_LIST,
    }
}

export const getAdminListSuccess = (data) => {
    return {
        type: GET_ADMIN_LIST_SUCCESS,
        payload: data,
    }
}

export const updateSalesOwner = data => {
    return {
        type: UPDATE_SALES_OWNER,
        payload: data,
    }
}

export const updateSalesOwnerSuccess = data => {
    return {
        type: UPDATE_SALES_OWNER_SUCCESS,
        payload: data,
    }
}

export const getStarredEntitiesList = data => {
  return {
    type: GET_STARRED_ENTITIES_INFO,
    payload: data,
  }
}

export const getStarredEntitiesListSuccess = data => {
  return {
    type: GET_STARRED_ENTITIES_INFO_SUCCESS,
    payload: data,
  }
}

export const getHiddenEntitiesList = data => {
  return {
    type: GET_HIDDEN_ENTITIES_INFO,
    payload: data,
  }
}

export const getHiddenEntitiesListSuccess = data => {
  return {
    type: GET_HIDDEN_ENTITIES_INFO_SUCCESS,
    payload: data,
  }
}

export const setAdmMemberActivityEntitiesStarHideLog = data => {
    return {
        type: SET_ENTITIES_STAR_HIDE_LOG,
        payload: data,
    }
}